import * as React from 'react'
import autobind from 'autobind-decorator'
import { Select } from 'antd'
const Option = Select.Option
import { ItemReference, QueryResult } from '../../stores/dataStore'
import '../../utils/linq'
import { dropdownRender } from './select-sign'

interface SelectionInputProps {
    className?: string
    searchable?: boolean
    disabled?: boolean
    nullable?: boolean
    minWidth?: number
    width?: number
    // readonly: boolean,
    content?: (item: any) => React.ReactElement<any>
    multiple?: boolean
    forcereload?: boolean
    searchQuery?: string
    placeholder?: string
    defaultValue?: any
    valueAsItemReference?: boolean,
    value: ItemReference | ItemReference[] | string | string[]
    onChange: (item: ItemReference | ItemReference[] | string | string[] | undefined) => void
    options?: SelectionItem[]
    query?: (searchQuery: string, selectedValue: any) => Promise<QueryResult<ItemReference>>
    hideText?: boolean
    url?: string
    showFooter? : boolean 

    // onAdd: (item: ItemReference) => void,
    // onRemove: (item: ItemReference) => void
}

interface SelectionInputState {
    isFetching: boolean
    url?: string
    isDirty: boolean
    searchQuery: string
    lastSearchQuery: string
    options: SelectionItem[]
    value?: string | string[]
    query?: (searchQuery: string, selectedValue: any) => Promise<QueryResult<ItemReference>>
    forcereload?: boolean,
    total: number
}

export interface SelectionItem {
    key: string
    text: string
    value: string
    object?: any
}

export default class SelectionInput extends React.Component<SelectionInputProps, SelectionInputState> {
    constructor(props: SelectionInputProps) {
        super(props)

        if (!props.options && !props.query) {
            throw Error('One of the \'options\' or \'query\' properties must be specified')
        }

        if (props.options && props.query) {
            throw Error('Only one of the \'options\' or \'query\' properties must be specified at the same time')
        }
        let value: string | string[] | undefined = undefined
        if (props.value) {
            if (props.value instanceof Array) {
                value = (this.props.value as any[]).map((o) => o.id || o)
            } else {
                if ((this.props.value as ItemReference).id) {
                    value = (this.props.value as ItemReference).id
                } else {
                    value = this.props.value as string
                }
            }
        }

        this.state = {
            isFetching: false,
            isDirty: false,
            searchQuery: props.searchQuery || "",
            lastSearchQuery: "",
            options: (props.options || [] as SelectionItem[]),
            value,
            query: this.props.query,
            url: this.props.url,
            forcereload: this.props.forcereload,
            total: 0
        }
        if (this.state.value)
            this.reload()

        if (this.props.defaultValue) {
            this.reload()
        }
    }

    componentDidUpdate(prevProps: SelectionInputProps, prevState: SelectionInputState, snapshot: any) {
        if (JSON.stringify(this.props.value || '""') !== JSON.stringify(prevProps.value || '""')) {
            if (Array.isArray(this.props.value)) {
                this.setState({ value: this.props.value as any }, () => this.reload())
                return
            } else {
                this.setState({ value: (this.props.value ? `${this.props.value}` : this.props.value) as any }, () => {
                    if (this.state.options.all(o => o.key != this.props.value))
                        this.reload()
                })
            }
        }
        if (prevProps.url !== this.props.url) {
            let value: string | string[] | undefined = undefined
            if (this.props.value) {
                if (this.props.value instanceof Array) {
                    value = (this.props.value as ItemReference[]).map((o) => o.id)
                } else {
                    if ((this.props.value as ItemReference).id) {
                        value = (this.props.value as ItemReference).id
                    } else {
                        value = this.props.value as string
                    }
                }
            }
            this.setState({
                url: this.props.url,
                query: this.props.query,
                isFetching: false,
                isDirty: false,
                options: (this.props.options || [] as SelectionItem[]),
                value,
            }, () => {
                this.reload()
            })
        }
    }

    @autobind
    private handleChange(value: string | string[]) {
        if (value === undefined) {
            this.setState({ value: undefined, searchQuery: "" }, () => this.props.onChange(undefined))
            return
        }
        if (this.props.multiple) {
            this.props.onChange(value)
            this.setState({ value: value })
        } else {
            const filteredOptions = this.state.options.filter((o) => o.value === value)
            if (filteredOptions.length > 0) {
                const item: ItemReference | string = filteredOptions[0].object || filteredOptions[0].value
                this.props.onChange(item)
                this.setState({ value: filteredOptions[0].value })
            }
        }
    }

    timer: any
    @autobind
    private handleSearchChange(searchQuery: string) {
        clearTimeout(this.timer)
        this.timer = setTimeout(async () => {
            if (this.state.forcereload) {
                this.setState({ searchQuery }, () => this.reload())
                return
            }
            if (this.state.searchQuery != searchQuery) {
                this.setState({ searchQuery }, () => this.reload())
            }
        }, 800)


    }

    @autobind
    private async reload() {
        //if (this.state.lastSearchQuery == this.state.searchQuery && this.state.options.any(o => o.key == this.state.value) && !this.state.forcereload)
        //    return

        const addContent = (item: any, obj: any) => {
            item.searchableText = item.text
            if (this.props.content) {
                item.text = this.props.content(obj)
            }
            return item
        }

        if (this.props.options) {
            this.setState({
                isDirty: false,
                isFetching: false,
                options: this.props.options.filter((o) => o.text.includes(this.state.searchQuery)).map((o) => addContent(o, o))
            })
            return
        }

        if (this.state.isFetching) {
            this.setState({ isDirty: true })
            return
        }

        this.setState({ isFetching: true })
        const queryResult = await this.state.query!(this.state.searchQuery, this.state.value)

        if (!this.props.multiple) {
            var itemReference = (this.props.value as ItemReference)
            if (this.props.value && queryResult.items.filter((o) => o.id == (itemReference.id ? itemReference : this.props.value)).length === 0) {
                const item = (this.props.value as ItemReference)
                queryResult.items.push({
                    id: item.id,
                    title:  item.title
                })
            }
        }
        else {
            var itemReferenceArray = (this.props.value as ItemReference[])
            if (itemReferenceArray) {
                itemReferenceArray.map(t => {
                    if (t && t.id && queryResult.items.filter((o) => o.id === t.id).length === 0) {
                        queryResult.items.push({
                            id: t.id,
                            title: t.title
                        })
                    }
                }
                )
            }
        }
        let options = (queryResult.items || []).map((o) => addContent({
            key: o.id == null ? 'NULL_VALUE' : o.id,
            value: o.id,
            text: o.title,
            object: o
        } as SelectionItem, o))

        const total = queryResult.count || 0

        //if (this.state.options) {
        //    this.state.options.forEach((o) => {
        //        if (options.filter((e) => e.value === o.value).length === 0) {
        //            options.push(o);
        //        }
        //    });
        //    options = options.orderBy((o) => o.value) as any[];
        //}

        //if (this.props.nullable && options.filter((o) => o.value == null).length === 0) {
        //    options.push({
        //        key: '',
        //        object: null,
        //        text: this.props.placeholder || '',
        //        value: ""
        //    } as SelectionItem);
        //}

        let changedItem: any = undefined
        var value = this.state.value
        if (!this.props.nullable && (this.state.value == null || this.state.value.length === 0) && options.length > 0) {
            const item: ItemReference = options[0].object || { id: options[0].value, title: options[0].text }
            if (this.props.multiple) {
                changedItem = [item]
                value = [options[0].value]
            } else {
                changedItem = item
                value = options[0].value
            }
        }

        if (value && !Array.isArray(value)) {
            if (options.filter(o => o.key == value).length == 0) {
                value = undefined
            }
        }

        const isDirty = this.state.isDirty
        this.setState(
            {
                options,
                value: Array.isArray(value) ? value : (value ? `${value}` : undefined),
                isFetching: false,
                isDirty: false,
                lastSearchQuery: this.state.searchQuery,
                total: total
            })

        if (changedItem) {
            this.props.onChange(this.props.valueAsItemReference ? changedItem : value)
        }

        if (isDirty) {
            setTimeout(() => this.reload())
        }
    }

    render() {
        const { isFetching, options, value, total } = this.state
        const { multiple, searchable, placeholder, hideText } = this.props

        return <Select style={{ minWidth: this.props.minWidth, width: this.props.width || '100%' }}
            className={this.props.className}
            mode={multiple ? 'multiple' : 'default'}
            disabled={this.props.disabled}
            allowClear={this.props.nullable}
            value={this.props.valueAsItemReference ? (!value ? undefined : ((value as any).id || value)) : value}
            placeholder={placeholder}
            defaultValue={this.props.defaultValue}
            loading={isFetching}
            filterOption={false}
            autoClearSearchValue={true}
            showSearch={searchable}
            onChange={(o: any) => this.handleChange(o)}
            onDropdownVisibleChange={() => this.reload()}
            onSearch={this.handleSearchChange}
            dropdownRender={this.props.showFooter && total && options.length && total > options.length ? (menu) => dropdownRender(menu, this.state.total, this.state.options.length) : undefined}
        >
            {options.map(o => <Option key={o.key} value={o.value}>
                {this.props.content ? this.props.content(o.object) : <span>{o.text}</span>}
            </Option>)}
        </Select>
    }
}